import { FC } from "react";
import styles from './index.less';
import { Button } from "react-vant";

interface BottomSignProps {
  click: () => void;
  // title: string;
  // list: Array<any>;
  text?: string;
  loading: boolean
}

const BottomButton: FC<BottomSignProps> = (props) => {
  const {click, text, loading } = props;
  return (
    <>
      <div>
        <div className={styles.bottomButtonContainer} onClick={click}>
        <Button type='primary' loading={loading} block round>
          {text? text : '报名'}
        </Button>
        </div>
      </div>
    </>
  );
};

export default BottomButton